import React from 'react';
import Main from '../Main';
import { ToastProvider } from 'react-toast-notifications';
import { Redirect } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import Authentication from '../Authentication';

import { useSelector } from 'react-redux';

const auth = new Authentication();

export const MainRoute = () => {
  const login = useSelector(state => state.login);
  const [redirect, setRedirect] = React.useState(!login.loggedIn);
  const loginPath = '/login';

  React.useEffect(() => {
    setRedirect(!login.loggedIn);
  }, [login]);

  const content = React.useMemo(() => {
    return [<Main key={0} auth={auth} />];
  }, []);

  return (
    <ToastProvider>
      {redirect && <Redirect to={loginPath} />}
      <ErrorBoundary>{content}</ErrorBoundary>
    </ToastProvider>
  );
};